import isLoadedReduxSelector from 'modules/redux/selectors/is-loaded'
import {
  SQUAD_KEY,
  SQUAD_PATH
} from 'modules/squad/redux/constants'

const isInfoLoadedSquadSelect = state => {
  const path = SQUAD_PATH[SQUAD_KEY.INFO]
  return isLoadedReduxSelector(path)(state)
}

export default isInfoLoadedSquadSelect
